export const COLLECTIONS = {
  users: 'users',
  authorProfiles: 'authorProfiles',
  projects: 'projects',
  chapters: 'chapters',
  versions: 'versions',
  notes: 'notes',
  commentThreads: 'commentThreads',
  changes: 'changes',
  chapterMutations: 'chapterMutations',
  replies: 'replies',
  assets: 'assets',
  collaborators: 'collaborators',
  presence: 'presence',
  invites: 'invites',
  aiRuns: 'aiRuns',
  storyBible: 'storyBible',
  revisionLocks: 'revisionLocks',
  storyMemory: 'storyMemory',
  styleGuides: 'styleGuides',
  continuity: 'continuity',
  sourceDocs: 'sourceDocs',
  characterRelationships: 'characterRelationships',
  characters: 'characters',
  codex: 'codex',
  ideaCards: 'ideaCards',
  ragChunks: 'ragChunks',
  ragMeta: 'ragMeta',
  sceneCards: 'sceneCards',
  timelineEvents: 'timelineEvents',
  writingGoals: 'writingGoals',
  writingSessions: 'writingSessions',
  deadlines: 'deadlines',
  publishReadiness: 'publishReadiness',
  assistantTools: 'assistantTools',
  assistantResults: 'assistantResults',
  consistencyReports: 'consistencyReports',
  exports: 'exports',
  jobs: 'jobs',
  jobCapacity: 'jobCapacity',
  assemblyManifests: 'assemblyManifests',
  assemblySnapshots: 'assemblySnapshots',
  assemblyFragments: 'assemblyFragments',
  assemblyBuilds: 'assemblyBuilds',
  assemblyState: 'assemblyState',
  activity: 'activity',
  titles: 'titles',
  titleAssets: 'titleAssets',
  orders: 'orders',
  licenses: 'licenses',
  subscriptions: 'subscriptions',
  payouts: 'payouts',
  promotionPartners: 'promotionPartners',
  affiliateApplications: 'affiliateApplications',
  affiliateClicks: 'affiliateClicks',
  attributionClaims: 'attributionClaims',
  attributionAdjustments: 'attributionAdjustments',
  referralRewards: 'referralRewards',
  discountCodes: 'discountCodes',
  discountRedemptions: 'discountRedemptions',
  discountCustomerUsage: 'discountCustomerUsage',
  discountAttempts: 'discountAttempts',
  discountFirstPurchaseClaims: 'discountFirstPurchaseClaims',
  discountAdjustments: 'discountAdjustments',
  orderAttributions: 'orderAttributions',
  payoutStatements: 'payoutStatements',
  webhookEvents: 'webhookEvents',
  commerceInvoices: 'commerceInvoices',
  commerceCounters: 'commerceCounters',
  commerceEmailOutbox: 'commerceEmailOutbox',
  commerceEmailEvents: 'commerceEmailEvents',
  commerceFulfillmentCorrections: 'commerceFulfillmentCorrections',
  orderEffects: 'orderEffects',
  notifications: 'notifications',
  accountSavedItems: 'accountSavedItems',
  accountDownloadEvents: 'accountDownloadEvents',
  behaviorAssessments: 'behaviorAssessments',
  behaviorAssessmentStats: 'behaviorAssessmentStats',
  behaviorAssessmentEmails: 'behaviorAssessmentEmails',
  flags: 'flags',
  moderationEvidence: 'moderationEvidence',
  collections: 'collections',
  templates: 'templates',
  curatedStudioTemplates: 'curatedStudioTemplates',
  blogPosts: 'blogPosts',
  blogRevisions: 'revisions',
  blogPreviewTokens: 'blogPreviewTokens',
  blogMediaAssets: 'blogMediaAssets',
  blogSlugClaims: 'blogSlugClaims',
  funnelPages: 'funnelPages',
  marketingLeads: 'marketingLeads',
  analyticsEvents: 'analyticsEvents',
  analyticsDaily: 'analyticsDaily',
  analyticsRollupDays: 'analyticsRollupDays',
  analyticsAttributionDays: 'analyticsAttributionDays',
  analyticsCohorts: 'analyticsCohorts',
  analyticsReconciliationRuns: 'analyticsReconciliationRuns',
  analyticsReconciliationState: 'analyticsReconciliationState',
  storageInventoryJobs: 'storageInventoryJobs',
  storageInventoryState: 'storageInventoryState',
  storageInventoryReferencedPaths: 'storageInventoryReferencedPaths',
  storageInventoryReferenceRecords: 'storageInventoryReferenceRecords',
  storageInventoryFiles: 'storageInventoryFiles',
  storageInventoryFindings: 'storageInventoryFindings',
  platformSettings: 'platformSettings',
  privatePlatformSettings: 'privatePlatformSettings',
  categoryPlaybooks: 'categoryPlaybooks',
  auditLogs: 'auditLogs',
} as const;

export const usersPath = () => COLLECTIONS.users;
export const userPath = (uid: string) => `${COLLECTIONS.users}/${uid}`;
export const authorProfilesPath = () => COLLECTIONS.authorProfiles;
export const authorProfilePath = (authorId: string) => `${COLLECTIONS.authorProfiles}/${authorId}`;
export const titleAssetPath = (assetId: string) => `${COLLECTIONS.titleAssets}/${assetId}`;
export const projectsPath = () => COLLECTIONS.projects;
export const projectPath = (projectId: string) => `${COLLECTIONS.projects}/${projectId}`;
export const projectChaptersPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.chapters}`;
export const projectChapterPath = (projectId: string, chapterId: string) => `${projectChaptersPath(projectId)}/${chapterId}`;
export const projectVersionsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.versions}`;
export const projectVersionPath = (projectId: string, versionId: string) => `${projectVersionsPath(projectId)}/${versionId}`;
export const projectNotesPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.notes}`;
export const projectChapterCommentThreadsPath = (projectId: string, chapterId: string) => `${projectChapterPath(projectId, chapterId)}/${COLLECTIONS.commentThreads}`;
export const projectChapterCommentThreadPath = (projectId: string, chapterId: string, threadId: string) => `${projectChapterCommentThreadsPath(projectId, chapterId)}/${threadId}`;
export const projectChapterCommentRepliesPath = (projectId: string, chapterId: string, threadId: string) => `${projectChapterCommentThreadPath(projectId, chapterId, threadId)}/${COLLECTIONS.replies}`;
export const projectChapterCommentReplyPath = (projectId: string, chapterId: string, threadId: string, replyId: string) => `${projectChapterCommentRepliesPath(projectId, chapterId, threadId)}/${replyId}`;
export const projectChapterChangesPath = (projectId: string, chapterId: string) => `${projectChapterPath(projectId, chapterId)}/${COLLECTIONS.changes}`;
export const projectChapterChangePath = (projectId: string, chapterId: string, changeId: string) => `${projectChapterChangesPath(projectId, chapterId)}/${changeId}`;
export const projectChapterMutationsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.chapterMutations}`;
export const projectChapterMutationPath = (projectId: string, mutationId: string) => `${projectChapterMutationsPath(projectId)}/${mutationId}`;
export const projectAssetsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.assets}`;
export const projectAssetPath = (projectId: string, assetId: string) => `${projectAssetsPath(projectId)}/${assetId}`;
export const projectCollaboratorsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.collaborators}`;
export const projectPresencePath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.presence}`;
export const projectPresenceMemberPath = (projectId: string, uid: string) => `${projectPresencePath(projectId)}/${uid}`;
export const projectInvitesPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.invites}`;
export const projectInvitePath = (projectId: string, inviteId: string) => `${projectInvitesPath(projectId)}/${inviteId}`;
export const projectAiRunsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.aiRuns}`;
export const projectStoryBiblePath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.storyBible}/main`;
export const projectRevisionLocksPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.revisionLocks}`;
export const projectStoryMemoryPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.storyMemory}`;
export const projectStyleGuidesPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.styleGuides}`;
export const projectContinuityPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.continuity}`;
export const projectSourceDocsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.sourceDocs}`;
export const projectSourceDocPath = (projectId: string, sourceId: string) => `${projectSourceDocsPath(projectId)}/${sourceId}`;
export const projectCharactersPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.characters}`;
export const projectCharacterPath = (projectId: string, characterId: string) => `${projectCharactersPath(projectId)}/${characterId}`;
export const projectCharacterRelationshipsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.characterRelationships}`;
export const projectCharacterRelationshipPath = (projectId: string, relationshipId: string) => `${projectCharacterRelationshipsPath(projectId)}/${relationshipId}`;
export const projectCodexPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.codex}`;
export const projectCodexEntryPath = (projectId: string, entryId: string) => `${projectCodexPath(projectId)}/${entryId}`;
export const projectIdeaCardsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.ideaCards}`;
export const projectIdeaCardPath = (projectId: string, cardId: string) => `${projectIdeaCardsPath(projectId)}/${cardId}`;
export const projectRagChunksPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.ragChunks}`;
export const projectRagChunkPath = (projectId: string, chunkId: string) => `${projectRagChunksPath(projectId)}/${chunkId}`;
export const projectRagMetaPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.ragMeta}/status`;
export const projectSceneCardsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.sceneCards}`;
export const projectSceneCardPath = (projectId: string, sceneId: string) => `${projectSceneCardsPath(projectId)}/${sceneId}`;
export const projectTimelineEventsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.timelineEvents}`;
export const projectTimelineEventPath = (projectId: string, eventId: string) => `${projectTimelineEventsPath(projectId)}/${eventId}`;
export const projectWritingGoalsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.writingGoals}`;
export const projectWritingGoalPath = (projectId: string, goalId: string) => `${projectWritingGoalsPath(projectId)}/${goalId}`;
export const projectWritingSessionsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.writingSessions}`;
export const projectWritingSessionPath = (projectId: string, sessionId: string) => `${projectWritingSessionsPath(projectId)}/${sessionId}`;
export const projectDeadlinesPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.deadlines}`;
export const projectDeadlinePath = (projectId: string, deadlineId: string) => `${projectDeadlinesPath(projectId)}/${deadlineId}`;
export const projectPublishReadinessPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.publishReadiness}/main`;
export const projectAssistantToolsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.assistantTools}`;
export const projectAssistantToolPath = (projectId: string, toolId: string) => `${projectAssistantToolsPath(projectId)}/${toolId}`;
export const projectAssistantResultsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.assistantResults}`;
export const projectAssistantResultPath = (projectId: string, resultId: string) => `${projectAssistantResultsPath(projectId)}/${resultId}`;
export const projectConsistencyReportsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.consistencyReports}`;
export const projectConsistencyReportPath = (projectId: string, reportId: string) => `${projectConsistencyReportsPath(projectId)}/${reportId}`;
export const projectExportsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.exports}`;
export const projectJobsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.jobs}`;
export const projectJobPath = (projectId: string, jobId: string) => `${projectJobsPath(projectId)}/${jobId}`;
export const projectJobCapacityPath = (projectId: string, capacityId: string) => `${projectPath(projectId)}/${COLLECTIONS.jobCapacity}/${capacityId}`;
export const projectAssemblyManifestsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.assemblyManifests}`;
export const projectAssemblyManifestPath = (projectId: string, manifestId: string) => `${projectAssemblyManifestsPath(projectId)}/${manifestId}`;
export const projectAssemblySnapshotsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.assemblySnapshots}`;
export const projectAssemblySnapshotPath = (projectId: string, snapshotId: string) => `${projectAssemblySnapshotsPath(projectId)}/${snapshotId}`;
export const projectAssemblyFragmentsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.assemblyFragments}`;
export const projectAssemblyFragmentPath = (projectId: string, chapterId: string) => `${projectAssemblyFragmentsPath(projectId)}/${chapterId}`;
export const projectAssemblyBuildsPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.assemblyBuilds}`;
export const projectAssemblyBuildPath = (projectId: string, buildId: string) => `${projectAssemblyBuildsPath(projectId)}/${buildId}`;
export const projectAssemblyStatePath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.assemblyState}/main`;
export const projectActivityPath = (projectId: string) => `${projectPath(projectId)}/${COLLECTIONS.activity}`;
export const titlesPath = () => COLLECTIONS.titles;
export const titlePath = (titleId: string) => `${COLLECTIONS.titles}/${titleId}`;
export const ordersPath = () => COLLECTIONS.orders;
export const orderPath = (orderId: string) => `${COLLECTIONS.orders}/${orderId}`;
export const payoutsPath = () => COLLECTIONS.payouts;
export const payoutPath = (payoutId: string) => `${COLLECTIONS.payouts}/${payoutId}`;
export const promotionPartnersPath = () => COLLECTIONS.promotionPartners;
export const promotionPartnerPath = (partnerId: string) => `${COLLECTIONS.promotionPartners}/${partnerId}`;
export const discountCodesPath = () => COLLECTIONS.discountCodes;
export const discountCodePath = (discountCodeId: string) => `${COLLECTIONS.discountCodes}/${discountCodeId}`;
export const discountRedemptionPath = (redemptionId: string) => `${COLLECTIONS.discountRedemptions}/${redemptionId}`;
export const discountCustomerUsagePath = (usageId: string) => `${COLLECTIONS.discountCustomerUsage}/${usageId}`;
export const discountAttemptPath = (attemptId: string) => `${COLLECTIONS.discountAttempts}/${attemptId}`;
export const discountFirstPurchaseClaimPath = (userUid: string) => `${COLLECTIONS.discountFirstPurchaseClaims}/${userUid}`;
export const discountAdjustmentPath = (adjustmentId: string) => `${COLLECTIONS.discountAdjustments}/${adjustmentId}`;
export const orderAttributionsPath = () => COLLECTIONS.orderAttributions;
export const orderAttributionPath = (attributionId: string) => `${COLLECTIONS.orderAttributions}/${attributionId}`;
export const payoutStatementsPath = () => COLLECTIONS.payoutStatements;
export const payoutStatementPath = (statementId: string) => `${COLLECTIONS.payoutStatements}/${statementId}`;
export const webhookEventsPath = () => COLLECTIONS.webhookEvents;
export const webhookEventPath = (eventId: string) => `${COLLECTIONS.webhookEvents}/${eventId}`;
export const commerceInvoicePath = (invoiceId: string) => `${COLLECTIONS.commerceInvoices}/${invoiceId}`;


export const subscriptionsPath = () => COLLECTIONS.subscriptions;
export const subscriptionPath = (uid: string) => `${COLLECTIONS.subscriptions}/${uid}`;
export const auditLogsPath = () => COLLECTIONS.auditLogs;
export const auditLogPath = (id: string) => `${COLLECTIONS.auditLogs}/${id}`;
export const moderationEvidencePath = (evidenceId: string) => `${COLLECTIONS.moderationEvidence}/${evidenceId}`;

export const curatedStudioTemplatesPath = () => COLLECTIONS.curatedStudioTemplates;
export const curatedStudioTemplatePath = (templateId: string) => `${curatedStudioTemplatesPath()}/${templateId}`;
export const curatedStudioTemplateVersionsPath = (templateId: string) => `${curatedStudioTemplatePath(templateId)}/versions`;
export const curatedStudioTemplateVersionPath = (templateId: string, versionId: string) => `${curatedStudioTemplateVersionsPath(templateId)}/${versionId}`;

export const licensesPath = () => COLLECTIONS.licenses;
export const licensePath = (licenseId: string) => `${COLLECTIONS.licenses}/${licenseId}`;

export const blogPostsPath = () => COLLECTIONS.blogPosts;
export const blogPostPath = (postId: string) => `${COLLECTIONS.blogPosts}/${postId}`;
export const blogPostRevisionsPath = (postId: string) => `${blogPostPath(postId)}/${COLLECTIONS.blogRevisions}`;
export const blogPostRevisionPath = (postId: string, revisionId: string) => `${blogPostRevisionsPath(postId)}/${revisionId}`;
export const funnelPagesPath = () => COLLECTIONS.funnelPages;
export const funnelPagePath = (slug: string) => `${COLLECTIONS.funnelPages}/${slug}`;
export const marketingLeadsPath = () => COLLECTIONS.marketingLeads;
export const marketingLeadPath = (leadId: string) => `${COLLECTIONS.marketingLeads}/${leadId}`;
export const platformSettingsPath = () => COLLECTIONS.platformSettings;
export const platformSettingPath = (docId: string) => `${COLLECTIONS.platformSettings}/${docId}`;
export const privatePlatformSettingsPath = () => COLLECTIONS.privatePlatformSettings;
export const privatePlatformSettingPath = (docId: string) => `${COLLECTIONS.privatePlatformSettings}/${docId}`;

export const aiSettingsPath = () => platformSettingPath('ai');

export const categoryPlaybooksPath = () => COLLECTIONS.categoryPlaybooks;
export const categoryPlaybookPath = (categoryId: string) => `${COLLECTIONS.categoryPlaybooks}/${categoryId}`;

export const categoryPlaybookSourceDocsPath = (categoryId: string) => `${categoryPlaybookPath(categoryId)}/${COLLECTIONS.sourceDocs}`;
export const categoryPlaybookSourceDocPath = (categoryId: string, sourceId: string) => `${categoryPlaybookSourceDocsPath(categoryId)}/${sourceId}`;
